import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';
import {EntityLoanViewModel} from '../view-models/entity-loan.view-model';

import {EntityLoanCardComponent} from '../entity-loan-card/entity-loan-card.component';

@Component({
    selector: 'app-entity-loan-card-container',
    templateUrl: './entity-loan-card-container.component.html',
    styleUrls: ['./entity-loan-card-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntityLoanCardComponent]
})
export class EntityLoanCardContainerComponent {

  public readonly currentPage = input.required<PageViewModel<EntityLoanViewModel>>();

  public readonly cardClicked = output<EntityLoanViewModel>();

  handleCardClicked(entityLoanVM: EntityLoanViewModel): void {
    this.cardClicked.emit(entityLoanVM);
  }
}
